// extracted by mini-css-extract-plugin
module.exports = {"GlobeContainer":"Globe_GlobeContainer__3jeU8"};